import { h, Host, Component, Prop } from '@stencil/core';
import state from '../../state';
import { getViewportValue } from '../../utils';

@Component({
  tag: 'om-close-button',
  styleUrl: './close-button.css',
})
export class CloseButton {
  @Prop() handleClose: () => void;

  render() {
    return (
      <Host
        style={{
          '--close-button-color': getViewportValue(state.content[state.currentScreen]?.closeIcon, 'colour'),
        }}
      >
        <om-clickable-element class="close-btn-container" element={{ field: 'closeIcon' }}>
          <button
            tabindex="0"
            type="button"
            class="close-btn"
            onClick={() => {
              switch (state.mode) {
                case 'preview':
                  break;

                case 'test':
                  this.handleClose();
                  break;

                case 'live':
                  this.handleClose();
                  localStorage?.setItem('om:overlays_v2:has_rejected', 'true');
                  break;
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 14" fill="black">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" />
            </svg>
          </button>
        </om-clickable-element>
      </Host>
    );
  }
}
